import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../../../../store';
import {
    PromocodeDTO,
    PromocodeFormType,
    PROMOCODE_FORM_TYPE,
} from '../service/promocodes.interface';
import { promocodeApi } from '../service/promocode.api';
import { PaginatedResponse } from '../../../../communities/interfaces/PaginatedResponse';

interface State {
    current: PromocodeDTO | null;
    data: PaginatedResponse<PromocodeDTO>;
    formType: PromocodeFormType;
}

const initialState: State = {
    current: null,
    data: {
        items: [],
        total: 0,
    },
    formType: PROMOCODE_FORM_TYPE.UNIQUE,
};

export const promocodeSlice = createSlice({
    name: 'promocodesSelector',
    initialState,
    reducers: {
        setCurrentPromocode(state, action: PayloadAction<PromocodeDTO | null>) {
            state.current = action.payload;
        },
        setPromocodeFormType(
            state,
            action: PayloadAction<PromocodeFormType | null>
        ) {
            state.formType = action.payload;
        },
        clearCurrentPromocode(state) {
            state.current = null;
        },
    },
    extraReducers: builder => {
        builder.addMatcher(
            promocodeApi.endpoints.readPromocode.matchFulfilled,
            (state, { payload }) => {
                state.current = payload;
            }
        );
    },
});

export const selectPromocode = (state: RootState) => state.promocodesSelector;

export const { setCurrentPromocode, setPromocodeFormType } =
    promocodeSlice.actions;

export const promocodeReducer = promocodeSlice.reducer;
